<template>
    <ContentOrLoading>
        <ModalComponent
            :name="'editar-' + tempTag.id"
            :title="'Etiqueta ' + etiqueta.name"
            @close="close"
        >
            <h4 class="pb-4 text-center">Editar la etiqueta: {{ etiqueta.name }}</h4>
            <FormComponent :etiqueta="tempTag" @terminado="editar()"></FormComponent>
        </ModalComponent>
    </ContentOrLoading>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";
import FormComponent from "../FormComponent";

export default {
    props: ['etiqueta'],
    data() {
        return {
            tempTag: Object.assign({}, this.etiqueta)
        }
    },
    methods: {
        close() {
            this.$emit('close', 'editar-' + this.tempTag.id);
        },
        editar() {
            this.$emit('update', this.tempTag);
        }
    },
    watch: {
        etiqueta(newVal) {
            this.tempTag = Object.assign({}, newVal);
        }
    },
    components: {
        ModalComponent, FormComponent
    }
}
</script>
